const StepBackIcon = () => (
    <svg width="15" height="15" viewBox="0 0 15 16">
        <path d="M7.50621 0.499999L0.012427 7.99378L7.50621 15.5L8.82353 14.1827L3.59155 8.93828L15 8.93828L15 7.06172L3.59155 7.06172L8.83596 1.82974L7.50621 0.499999Z" />
    </svg>
);

export default StepBackIcon;
